import { Box, Grid } from "@mui/material";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import { Formik } from "formik";
import * as React from "react";
import { useMutation } from "react-query";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { v4 as uuidv4 } from "uuid";
import * as Yup from "yup";
import { FinalizePaymentSettlementRequest } from "../../models/supplierPayment.model";
import { FinalizePaymentSettlement } from "../../services/supplierPayment.service";
import MaterialTextFieldComponent from "../textField/MaterialTextFieldCmp";
const style = {
  position: "absolute" as "absolute",
  top: "40%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};
interface props {
  openModel: boolean;
  setSendConfirmation: any;
  setOpenVerifyModal: any;
  setReloadData: any;
  paymentKey: string;
  settlementAmount: number;
  allowRoute?: boolean;
}
export default function ModalPaymentSettlement({
  openModel,
  setSendConfirmation,
  setOpenVerifyModal,
  setReloadData,
  paymentKey,
  settlementAmount,
  allowRoute,
}: props) {
  const [open, setOpen] = React.useState<boolean>(openModel);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSendConfirmation(false);
    setOpenVerifyModal(false);
  };
  React.useEffect(() => {
    setOpen(openModel);
  }, [openModel]);
  const validationSchema = Yup.object().shape({
    chequeSayadNumber: Yup.string()
      .required("شماره صیادی اجباری می باشد")
      .nullable()
      .min(16, "شماره صیادی 16 رقم می باشد.")
      .max(16, "شماره صیادی 16 رقم می باشد."),
    description: Yup.string()
      .required("توضیحات اجباری می باشد")
      .nullable(),
  });
  const handleKeyDown = (event: any) => {
    var key = event.keyCode ? event.keyCode : event.which;

    if (!/[0-9]/.test(event.key) && key != 8 && key != 46) {
      event.preventDefault();
    }
  };
  const history = useHistory();

  const { mutate: FinalizePaymentSettlementMutate } = useMutation(
    FinalizePaymentSettlement,
    {
      onSuccess: (data: boolean) => {
        if (data) {
          toast.success(" عملیات با موفقیت انجام شد.");
          setReloadData(uuidv4());
          handleClose();
          // if (allowRoute) {
          window.sessionStorage.setItem(
            "key-tablePaymentSettlmentInfo",
            paymentKey!
          );

          history.push({
            pathname: `/Payment/SettlmentRegisterhistoryDetail`,
            state: {
              id: paymentKey,
              from: "",
              pageNumber: 1,
              clickOnBack: false,
            },
          });
          // history.push("/Payment/SettlementWithReceiver");
          // }
        } else {
          handleClose();
        }
      },
    }
  );
  function handleOnCompletedClick() {
    setSendConfirmation(true);
    setOpen(false);
    setOpenVerifyModal(false);
  }
  let initialValues = new FinalizePaymentSettlementRequest();
  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
      >
        <Formik
          initialValues={initialValues}
          onSubmit={(values) => {
            values.paymentSettlementKey = paymentKey;
            FinalizePaymentSettlementMutate(values);
          }}
          validateOnMount={true}
          validationSchema={validationSchema}
        >
          {({
            handleSubmit,
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
          }) => (
            <form onSubmit={handleSubmit}>
              <>
                <Grid>
                  <Box
                    sx={style}
                    style={{
                      borderRadius: "6px",
                      padding: "2px 40px 40px 40px",
                    }}
                    className="ModalCmp  "
                  >
                    <Grid
                      item
                      xs={12}
                      className="classCenter"
                      style={{ paddingTop: "5vh" }}
                    >
                      <span className="textFont16 colorDefaultFont">
                        آیا از
                        <span className="SuccessDefaultFont"> صدور چک </span>با
                        مبلغ&nbsp;
                        <span className="SuccessDefaultFont">
                          {" "}
                          {settlementAmount &&
                            settlementAmount.toLocaleString("fa")}{" "}
                          ریال
                        </span>
                        &nbsp; اطمینان دارید؟
                      </span>
                      <br />
                      <span
                        className="textFont14 colorDefaultFont"
                        style={{ top: "19px", position: "relative" }}
                      >
                        جهت دریافت استعلام صحت چک شماره صیادی آن را وارد نمایید
                      </span>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      // className="classCenter"
                      style={{ paddingTop: "56px" }}
                    >
                      <MaterialTextFieldComponent
                        placeHolder={"1234567890123456"}
                        label={"شماره صیادی"}
                        required={true}
                        value={values.chequeSayadNumber}
                        onChange={handleChange}
                        name="chequeSayadNumber"
                        id="chequeSayadNumber"
                        // onFocus={true}
                        inputProps={{ maxLength: 16, minLength: 16 }}
                        onKeyDown={handleKeyDown}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      // className="classCenter"
                      style={{ paddingTop: "29px", marginBottom: "20px" }}
                    >
                      <MaterialTextFieldComponent
                        className={"shadowTextField"}
                        label={"توضیحات"}
                        required={false}
                        rows={2}
                        value={
                          values.description == undefined
                            ? ""
                            : values.description
                        }
                        onChange={handleChange}
                        name="description"
                        id="outlined-textarea"
                        multiline
                        sx={{
                          "& .MuiOutlinedInput-root > .MuiInputBase-input ": {
                            fontSize: 13,
                            lineHeight: "2vh !important",
                            height: "6vh !important",
                          },

                          "& .MuiInputBase-root": {
                            height: "10vh !important",
                          },
                        }}
                        placeHolder={"توضیحات"}
                      />
                    </Grid>

                    <Grid container xs={12} style={{ paddingTop: "5vh" }}>
                      <Grid item xs={6} style={{ textAlign: "end" }}>
                        <Button
                          type="submit"
                          disabled={Object.keys(errors).length > 0}
                          className={`${
                            Object.keys(errors).length > 0
                              ? "btnForm disabledBtn  "
                              : "btnForm SuccessDefault "
                          }`}
                          // className={"btnForm SuccessDefault "}
                          style={{ width: "170px", marginLeft: "1vh" }}
                        >
                          ثبت
                        </Button>
                      </Grid>
                      <Grid item xs={6} style={{ paddingRight: "1vh" }}>
                        <Button
                          className="btnForm ComingBack"
                          style={{
                            width: "170px",
                            marginLeft: "1vh",
                            textAlign: "left",
                          }}
                          onClick={handleClose}
                        >
                          بازگشت
                        </Button>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              </>
            </form>
          )}
        </Formik>
      </Modal>
    </div>
  );
}
